const en = {
    foreignTitle: 'Foreign-currency tax review',
    foreignExplain: 'Map every credit allocation to its original position. Confirm the original legal VAT, deduction and latest reviewed tax evidence; cash exchange rates remain separate.',
    foreignEvidence: 'Credit tax evidence',
    creditPosition: 'Credit allocation position',
    originalPosition: 'Original allocation position',
    currentReview: 'Latest reviewed source',
    originalReview: 'Immutable original tax evidence',
    reviewPrerequisite: 'Review the source tax evidence before the credit. Missing evidence or a changed review blocks approval.',
    sourceMissing: 'No complete reviewed source evidence. Open the original invoice and complete its tax review.',
    title: 'Supplier commercial credit',
    review: 'Review supplier credit',
    source: 'Original supplier invoice',
    reason: 'Reason and source evidence',
    clearing: 'Pending input VAT correction account',
    zeroCode: 'Source treatment for zero VAT',
    EXEMPT: 'Exempt supply',
    SMALL_BUSINESS: 'Small business exemption',
    OUT_OF_SCOPE: 'Outside VAT scope',
    ZERO_RATE: 'Documented zero rate',
    SELF_ASSESSED: 'Recipient self-assessed VAT',
    save: 'Save review',
    cancel: 'Cancel',
    saved: 'Review saved',
    offset: 'Set off supplier credit',
    target: 'Same-supplier invoice to settle',
    amount: 'Amount',
    date: 'Actual setoff date',
    confirm: 'Confirm noncash setoff',
    loading: 'Loading',
    retry: 'Retry',
    explain: 'Retain the supplier original. Enter negative line prices for a manual commercial credit. Review the matching original invoice before approval. This creates no payment.',
    timing: 'Input VAT on an unpaid original is corrected with the effective reduction. For an already paid amount, the pending correction is released only by an actual refund or documented setoff.',
    refund: 'Record an actual supplier refund in Payments using direction Incoming and allocate it to this credit.',
    setoffExplain: 'The same supplier and currency are required. A setoff clears both open items without a bank movement or additional expense.',
    errors: {
        foreignFiscal: 'Review the latest original tax evidence and map every credit allocation to its exact original position.',
        reversalDependent: 'First reverse later refund or setoff allocations that depend on this tax correction, then retry.',
        asset: 'This acquisition is registered as a fixed asset. A reviewed, dated asset-cost correction must accompany the supplier credit before it can be posted.',
        review: 'Review the credit source and tax treatment first.',
        source: 'Choose the actual approved original from the same supplier and currency; source dates and signed amounts must match.',
        sourceLocked: 'Reverse or cancel dependent supplier credits before correcting the original.',
        capacity: 'This credit exceeds the remaining evidenced source amounts or tax buckets.',
        tax: 'Credit tax rates and input VAT entitlement must match the actual original.',
        zeroTax: 'Select the explicit source treatment for zero VAT.',
        clearing: 'Choose an active general liability account in the book currency for pending input VAT corrections.',
        locked: 'This credit is already posted or no longer editable.',
        offset: 'The selected amount, dates or same-supplier open items do not permit this setoff.',
        reason: 'Enter a meaningful reason and source evidence.',
    },
};
export const supplierCreditLabels = {
    en,
    de: {
        foreignTitle: 'Steuerprüfung bei Fremdwährung',
        foreignExplain: 'Ordnen Sie jede Gutschriftaufteilung ihrer Originalposition zu. Bestätigen Sie gesetzliche Steuer, Vorsteuerabzug und zuletzt geprüften Steuerstand; tatsächliche Zahlungskurse bleiben getrennt.',
        foreignEvidence: 'Steuernachweis der Gutschrift',
        creditPosition: 'Aufteilungsposition der Gutschrift',
        originalPosition: 'Aufteilungsposition des Originals',
        currentReview: 'Zuletzt geprüfter Steuerstand',
        originalReview: 'Unveränderlicher Steuerbeleg des Originals',
        reviewPrerequisite: 'Prüfen Sie den Steuerstand des Originals vor der Gutschrift. Fehlende Nachweise oder ein geänderter Prüfstand verhindern die Freigabe.',
        sourceMissing: 'Kein vollständiger geprüfter Steuernachweis. Öffnen Sie die Originalrechnung und vervollständigen Sie die Steuerprüfung.',
        title: 'Kaufmännische Lieferantengutschrift',
        review: 'Lieferantengutschrift prüfen',
        source: 'Ursprüngliche Lieferantenrechnung',
        reason: 'Grund und Herkunftsnachweis',
        clearing: 'Konto für ausstehende Vorsteuerkorrektur',
        zeroCode: 'Steuergrund des Originals bei null Vorsteuer',
        EXEMPT: 'Steuerbefreite Leistung',
        SMALL_BUSINESS: 'Kleinunternehmerbefreiung',
        OUT_OF_SCOPE: 'Nicht umsatzsteuerbar',
        ZERO_RATE: 'Belegter Nullsteuersatz',
        SELF_ASSESSED: 'Vom Empfänger geschuldete Umsatzsteuer',
        save: 'Prüfung speichern',
        cancel: 'Abbrechen',
        saved: 'Prüfung gespeichert',
        offset: 'Lieferantengutschrift verrechnen',
        target: 'Auszugleichende Rechnung desselben Lieferanten',
        amount: 'Betrag',
        date: 'Tatsächliches Verrechnungsdatum',
        confirm: 'Verrechnung ohne Geldbewegung bestätigen',
        loading: 'Wird geladen',
        retry: 'Erneut versuchen',
        explain: 'Das Lieferantenoriginal bleibt erhalten. Erfassen Sie eine manuelle kaufmännische Gutschrift mit negativen Positionspreisen. Prüfen Sie vor Freigabe die zugehörige Originalrechnung. Es entsteht keine Zahlung.',
        timing: 'Bei unbezahltem Original wird die Vorsteuer mit der wirksamen Entgeltminderung korrigiert. Für bereits bezahlte Beträge wird die ausstehende Korrektur erst mit tatsächlicher Erstattung oder belegter Verrechnung wirksam.',
        refund: 'Erfassen Sie eine tatsächliche Lieferantenerstattung unter Zahlungen mit Richtung Eingang und ordnen Sie diese Gutschrift zu.',
        setoffExplain: 'Lieferant und Währung müssen übereinstimmen. Die Verrechnung gleicht beide offenen Posten ohne Bankbewegung oder erneuten Aufwand aus.',
        errors: {
            foreignFiscal: 'Prüfen Sie den letzten Steuerstand des Originals und ordnen Sie jede Gutschriftaufteilung ihrer genauen Originalposition zu.',
            reversalDependent: 'Nehmen Sie zuerst spätere Erstattungs- oder Verrechnungszuordnungen zurück, die von dieser Steuerkorrektur abhängen. Wiederholen Sie danach die Korrektur.',
            asset: 'Diese Anschaffung ist als Anlage registriert. Vor Buchung der Lieferantengutschrift ist eine geprüfte, datierte Anlagenkostenkorrektur erforderlich.',
            review: 'Prüfen Sie zuerst Herkunft und Steuerbehandlung der Gutschrift.',
            source: 'Wählen Sie das tatsächlich freigegebene Original desselben Lieferanten in derselben Währung; Daten und Vorzeichen müssen passen.',
            sourceLocked: 'Korrigieren oder stornieren Sie zuerst die abhängigen Lieferantengutschriften.',
            capacity: 'Die Gutschrift übersteigt die verbleibenden belegten Originalbeträge oder Steueranteile.',
            tax: 'Steuersätze und Vorsteuerberechtigung müssen zum tatsächlichen Original passen.',
            zeroTax: 'Wählen Sie den ausdrücklichen Steuergrund des Originals bei null Vorsteuer.',
            clearing: 'Wählen Sie ein aktives allgemeines Verbindlichkeitskonto in Buchwährung für ausstehende Vorsteuerkorrekturen.',
            locked: 'Die Gutschrift ist bereits gebucht oder nicht mehr bearbeitbar.',
            offset: 'Betrag, Daten oder offene Posten desselben Lieferanten erlauben diese Verrechnung nicht.',
            reason: 'Erfassen Sie einen aussagekräftigen Grund mit Herkunftsnachweis.',
        },
    },
    es: {
        foreignTitle: 'Revisión fiscal en moneda extranjera',
        foreignExplain: 'Vincule cada distribución del abono a su posición original. Confirme el IVA legal, la deducción y la última revisión fiscal; los tipos de los pagos permanecen separados.',
        foreignEvidence: 'Justificante fiscal del abono',
        creditPosition: 'Posición de distribución del abono',
        originalPosition: 'Posición de distribución original',
        currentReview: 'Última revisión del origen',
        originalReview: 'Justificante fiscal original conservado',
        reviewPrerequisite: 'Revise la evidencia fiscal original antes del abono. La falta de pruebas o un cambio de revisión bloquean la aprobación.',
        sourceMissing: 'No hay evidencia fiscal revisada completa. Abra la factura original y complete su revisión fiscal.',
        title: 'Abono comercial del proveedor',
        review: 'Revisar abono del proveedor',
        source: 'Factura original del proveedor',
        reason: 'Motivo y prueba de origen',
        clearing: 'Cuenta de corrección pendiente del IVA soportado',
        zeroCode: 'Tratamiento original para IVA cero',
        EXEMPT: 'Operación exenta',
        SMALL_BUSINESS: 'Exención de pequeña empresa',
        OUT_OF_SCOPE: 'Fuera del ámbito del IVA',
        ZERO_RATE: 'Tipo cero documentado',
        SELF_ASSESSED: 'IVA autorrepercutido por el destinatario',
        save: 'Guardar revisión',
        cancel: 'Cancelar',
        saved: 'Revisión guardada',
        offset: 'Compensar abono del proveedor',
        target: 'Factura del mismo proveedor que se compensará',
        amount: 'Importe',
        date: 'Fecha real de compensación',
        confirm: 'Confirmar compensación sin efectivo',
        loading: 'Cargando',
        retry: 'Reintentar',
        explain: 'Se conserva el original del proveedor. Introduzca precios negativos para un abono comercial manual. Revise la factura original correspondiente antes de aprobar. No se crea ningún pago.',
        timing: 'En un original impagado, el IVA soportado se corrige con la reducción efectiva. Para importes ya pagados, la corrección pendiente se realiza únicamente con un reembolso real o una compensación documentada.',
        refund: 'Registre el reembolso real del proveedor en Pagos con dirección Entrada y asígnelo a este abono.',
        setoffExplain: 'Se requiere el mismo proveedor y moneda. La compensación liquida ambas partidas sin movimiento bancario ni gasto adicional.',
        errors: {
            foreignFiscal: 'Revise el último estado fiscal del origen y vincule cada distribución del abono a su posición original exacta.',
            reversalDependent: 'Revierta primero las asignaciones posteriores de reembolsos o compensaciones que dependen de esta corrección fiscal y vuelva a intentarlo.',
            asset: 'Esta adquisición está registrada como activo fijo. Antes de contabilizar el abono se necesita una corrección revisada y fechada del coste del activo.',
            review: 'Revise primero el origen y tratamiento fiscal del abono.',
            source: 'Seleccione el original aprobado real del mismo proveedor y moneda; las fechas y signos deben coincidir.',
            sourceLocked: 'Revierta o cancele primero los abonos de proveedor dependientes.',
            capacity: 'El abono supera los importes o cuotas fiscales restantes acreditados del original.',
            tax: 'Los tipos e IVA deducible deben coincidir con el original real.',
            zeroTax: 'Seleccione el tratamiento original explícito para IVA cero.',
            clearing: 'Seleccione una cuenta general de pasivo activa en moneda contable para las correcciones pendientes.',
            locked: 'Este abono ya está contabilizado o no puede editarse.',
            offset: 'El importe, las fechas o las partidas del mismo proveedor no permiten esta compensación.',
            reason: 'Introduzca un motivo significativo y prueba de origen.',
        },
    },
    fr: {
        foreignTitle: 'Contrôle fiscal en devise',
        foreignExplain: 'Rattachez chaque ventilation de l’avoir à sa position d’origine. Confirmez la TVA légale, la déduction et le dernier contrôle fiscal ; les taux des paiements restent distincts.',
        foreignEvidence: 'Justificatif fiscal de l’avoir',
        creditPosition: 'Position ventilée de l’avoir',
        originalPosition: 'Position ventilée d’origine',
        currentReview: 'Dernier contrôle de la source',
        originalReview: 'Justificatif fiscal d’origine conservé',
        reviewPrerequisite: 'Contrôlez les justificatifs fiscaux de la source avant l’avoir. Une preuve manquante ou un contrôle modifié bloque l’approbation.',
        sourceMissing: 'Aucun justificatif fiscal contrôlé complet. Ouvrez la facture d’origine et terminez son contrôle fiscal.',
        title: 'Avoir commercial fournisseur',
        review: 'Vérifier l’avoir fournisseur',
        source: 'Facture fournisseur originale',
        reason: 'Motif et justificatif d’origine',
        clearing: 'Compte de correction différée de TVA déductible',
        zeroCode: 'Traitement d’origine de TVA nulle',
        EXEMPT: 'Opération exonérée',
        SMALL_BUSINESS: 'Exonération petite entreprise',
        OUT_OF_SCOPE: 'Hors champ de TVA',
        ZERO_RATE: 'Taux zéro justifié',
        SELF_ASSESSED: 'TVA autoliquidée par le destinataire',
        save: 'Enregistrer la vérification',
        cancel: 'Annuler',
        saved: 'Vérification enregistrée',
        offset: 'Compenser l’avoir fournisseur',
        target: 'Facture du même fournisseur à régler',
        amount: 'Montant',
        date: 'Date réelle de compensation',
        confirm: 'Confirmer la compensation sans trésorerie',
        loading: 'Chargement',
        retry: 'Réessayer',
        explain: 'L’original fournisseur est conservé. Saisissez des prix négatifs pour un avoir commercial manuel. Vérifiez la facture originale correspondante avant validation. Aucun paiement n’est créé.',
        timing: 'Pour un original impayé, la TVA déductible est corrigée lors de la réduction effective. Pour les montants déjà payés, la correction différée intervient uniquement avec un remboursement réel ou une compensation justifiée.',
        refund: 'Enregistrez le remboursement fournisseur réel dans Paiements avec le sens Entrée et affectez-le à cet avoir.',
        setoffExplain: 'Le fournisseur et la devise doivent correspondre. La compensation solde les deux postes sans mouvement bancaire ni nouvelle charge.',
        errors: {
            foreignFiscal: 'Contrôlez le dernier état fiscal de l’origine et rattachez chaque ventilation de l’avoir à sa position exacte.',
            reversalDependent: 'Annulez d’abord les imputations ultérieures de remboursements ou compensations qui dépendent de cette correction fiscale, puis réessayez.',
            asset: 'Cette acquisition est inscrite au registre des immobilisations. Une correction du coût vérifiée et datée est nécessaire avant de comptabiliser l’avoir fournisseur.',
            review: 'Vérifiez d’abord l’origine et le traitement fiscal de l’avoir.',
            source: 'Choisissez l’original réel validé du même fournisseur et de la même devise ; dates et signes doivent correspondre.',
            sourceLocked: 'Extournez ou annulez d’abord les avoirs fournisseur dépendants.',
            capacity: 'L’avoir dépasse les montants ou parts fiscales justifiés restant sur l’original.',
            tax: 'Les taux et le droit à déduction doivent correspondre à l’original réel.',
            zeroTax: 'Choisissez le traitement d’origine explicite pour la TVA nulle.',
            clearing: 'Choisissez un compte général de passif actif en devise comptable pour les corrections différées.',
            locked: 'Cet avoir est déjà comptabilisé ou n’est plus modifiable.',
            offset: 'Le montant, les dates ou les postes du même fournisseur ne permettent pas cette compensation.',
            reason: 'Saisissez un motif précis avec un justificatif d’origine.',
        },
    },
    tr: {
        foreignTitle: 'Yabancı para vergi incelemesi',
        foreignExplain: 'Her alacak notu dağılımını asıl kalemine bağlayın. Yasal KDV, indirim ve son incelenen vergi kanıtını doğrulayın; gerçek ödeme kurları ayrı kalır.',
        foreignEvidence: 'Alacak notu vergi kanıtı',
        creditPosition: 'Alacak notu dağılım kalemi',
        originalPosition: 'Asıl dağılım kalemi',
        currentReview: 'Son incelenen kaynak',
        originalReview: 'Değişmez asıl vergi kanıtı',
        reviewPrerequisite: 'Alacak notundan önce asıl vergi kanıtını inceleyin. Eksik kanıt veya değişen inceleme onayı engeller.',
        sourceMissing: 'Eksiksiz incelenmiş vergi kanıtı yok. Asıl faturayı açıp vergi incelemesini tamamlayın.',
        title: 'Tedarikçi ticari alacak dekontu',
        review: 'Tedarikçi alacak dekontunu incele',
        source: 'Asıl tedarikçi faturası',
        reason: 'Gerekçe ve kaynak kanıtı',
        clearing: 'Bekleyen indirilecek KDV düzeltme hesabı',
        zeroCode: 'Sıfır KDV için asıl belge uygulaması',
        EXEMPT: 'Vergiden istisna işlem',
        SMALL_BUSINESS: 'Küçük işletme istisnası',
        OUT_OF_SCOPE: 'KDV kapsamı dışında',
        ZERO_RATE: 'Belgelenmiş sıfır oran',
        SELF_ASSESSED: 'Alıcının hesapladığı KDV',
        save: 'İncelemeyi kaydet',
        cancel: 'İptal',
        saved: 'İnceleme kaydedildi',
        offset: 'Tedarikçi alacağını mahsup et',
        target: 'Kapatılacak aynı tedarikçi faturası',
        amount: 'Tutar',
        date: 'Gerçek mahsup tarihi',
        confirm: 'Nakit hareketi olmadan mahsubu onayla',
        loading: 'Yükleniyor',
        retry: 'Yeniden dene',
        explain: 'Tedarikçi aslı korunur. Manuel ticari alacak dekontu için negatif satır fiyatları girin. Onaydan önce ilgili asıl faturayı inceleyin. Ödeme oluşturulmaz.',
        timing: 'Ödenmemiş asılda indirilecek KDV, bedelin fiilen azalmasıyla düzeltilir. Önceden ödenen tutarlarda bekleyen düzeltme ancak gerçek iade veya belgelenmiş mahsupla gerçekleşir.',
        refund: 'Gerçek tedarikçi iadesini Ödemeler bölümünde Giriş yönüyle kaydedin ve bu dekonta tahsis edin.',
        setoffExplain: 'Tedarikçi ve para birimi aynı olmalıdır. Mahsup, banka hareketi veya yeni gider olmadan iki açık kalemi kapatır.',
        errors: {
            foreignFiscal: 'Asıl kaynağın son vergi durumunu inceleyip her alacak notu dağılımını tam asıl kalemine bağlayın.',
            reversalDependent: 'Önce bu vergi düzeltmesine bağlı sonraki iade veya mahsup eşleştirmelerini geri alın, ardından yeniden deneyin.',
            asset: 'Bu edinim sabit varlık olarak kayıtlıdır. Tedarikçi dekontu kaydedilmeden önce incelenmiş ve tarihli bir varlık maliyeti düzeltmesi gereklidir.',
            review: 'Önce dekont kaynağını ve vergi uygulamasını inceleyin.',
            source: 'Aynı tedarikçi ve para birimindeki gerçek onaylı aslı seçin; tarihler ve işaretler uyuşmalıdır.',
            sourceLocked: 'Önce bağlı tedarikçi alacak dekontlarını ters kaydedin veya iptal edin.',
            capacity: 'Dekont, asıldan kalan kanıtlanmış tutar veya vergi payını aşıyor.',
            tax: 'Vergi oranları ve KDV indirim hakkı gerçek asılla uyuşmalıdır.',
            zeroTax: 'Sıfır KDV için açık kaynak uygulamasını seçin.',
            clearing: 'Bekleyen düzeltmeler için defter para biriminde etkin genel borç hesabı seçin.',
            locked: 'Bu dekont zaten kaydedilmiş veya artık düzenlenemiyor.',
            offset: 'Tutar, tarihler veya aynı tedarikçinin açık kalemleri bu mahsuba izin vermiyor.',
            reason: 'Anlamlı bir gerekçe ve kaynak kanıtı girin.',
        },
    },
};
//# sourceMappingURL=supplier-credits.js.map